import * as actionTypes from "../actions/actionTypes";
import { cloneDeep } from "lodash";

const initState = {
  graderList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGrader: false,
  graderDetail:{},
  isProcessLoadGraderDetail: false,
  removeGraderConfirm: null,
  isRecoveryGraderSuccess: false,
  isUpdateGraderStatusSuccess: false,
  isUpdateGraderStatusFail: false,
  isUpdateGraderVerifyStatusSuccess: false,
  isUpdateGraderVerifyStatusFail: false,
  isRejectGraderVerifyStatusSuccess: false,
  isRejectGraderVerifyStatusFail: false,
  isUpdatePrinterBindingSuccess: false,
  isUpdatePrinterBindingFail: false,
  isUpdateGraderDetailSuccess: false,
  isUpdateGraderDetailFail: false,
  isUpdateGraderQRCodeSuccess: false,
  isUpdateGraderQRCodeFail: false,
  isUpdateGraderPublishStatusSuccess: false,
  graderCount:{},
  proceedUpdateOrderLandfill: false,
  activeOrderList: null,
  proceedDeactivateConfirm: false,
  confirmData: null,

  graderDeviceList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderDevice: false,
  isLogoutGraderDeviceSuccess: false,
  isLogoutGraderDeviceFail: false,
  isRemoveGraderDeviceSuccess: false,
  isRemoveGraderDeviceFail: false,
  isUpdateGraderDeviceDevSuccess: false,
  isUpdateGraderDeviceDevFail: false,

  isUploadGraderDocSuccess: false,
  isUploadGraderBizImageSuccess: false,
  isRemoveGraderBizImageSuccess: false,
  graderDocumentationCount: {},
  graderDocumentList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderDocument:false,
  isApproveGraderDocumentSuccess:false,
  isRejectGraderDocumentSuccess: false,
  
  graderZoneList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderZone: false,
  graderZoneCount: {},
  expressPackingHistoryList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  isProcessLoadExpressPackingHistoryList: false,
  expressPackingDetail: {},
  recyclingPackingHistoryList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    },
    exportSuccess: false
  },
  isProcessLoadRecyclingPackingHistoryList: false,
  recyclingPackingDetail: {},
  recyclingPackingPDF: "",
  recyclingPackingListStack: [],
  expressPackingPDF: "",
  expressPackingListStack: [],

  graderCarbonStockList: [],
  isSetGraderCarbonStockSuccess: false,
  isSetGraderCarbonStockFail: false,
  isRemoveGraderCarbonStockSuccess: false,
  isRemoveGraderCarbonStockFail: false,

  graderPrinterList: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderPrinter: false,
  graderPrinterCount: {},
  graderPrinterDetail: {},
  isProcessLoadGraderPrinterDetail: false,
  isCreateGraderPrinterSuccess: false,
  isCreateGraderPrinterFail: false,
  isUpdateGraderPrinterSuccess: false,
  isUpdateGraderPrinterFail: false,
  isRemoveGraderPrinterSuccess: false,
  isRemoveGraderPrinterFail: false,
  editGraderPrinterConfirm: null,
  removeGraderPrinterConfirm: null,
  graderPrinterTaskDistance: null,
  isProcessGraderPrinterTaskDistance: false,
  graderPrinterStatusLog: {
    data: [],
    offset: 0,
    limit: 10,
    meta: {
      page: 1,
      pageSize: 0,
      pageTotal: 1,
      total: 0,
      pageSizeOptions: [5, 10, 20, 30, 50, 100]
    }
  },
  isProcessLoadGraderPrinterStatusLog: false,
};
   
export default function graderReducer(state = initState, action) {

  switch (action.type) {
    case actionTypes.LOAD_GRADER_LIST: {
      let graderList = cloneDeep(state.graderList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderList.offset = action.data.offset;
        graderList.limit = action.data.limit;
      }

      return {
        ...state,
        graderList,
        isProcessLoadGrader: true,
      };
    }

    case actionTypes.LOAD_GRADER_LIST_SUCCESS: {
      let graderList = cloneDeep(state.graderList);
      graderList.data = action.data.data;
      graderList.meta = {
        page: 1 + state.graderList.offset / state.graderList.limit,
        pageSize: state.graderList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        isProcessLoadGrader: false,
        graderList
      };
    }

    case actionTypes.LOAD_GRADER_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGrader: false,
      };
    }

    
    case actionTypes.GRADER_COUNT: {
      
      return {
        ...state,
        graderCount: {}
      };
    }

    case actionTypes.GRADER_COUNT_SUCCESS: {
    
      return {
        ...state,
        graderCount:action.data
      };
    }

    case actionTypes.GRADER_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.LOAD_GRADER_DETAIL: {
      let graderDetail = cloneDeep(state.graderDetail);
      
      return {
        ...state,
        graderDetail,
        isProcessLoadGraderDetail: true,
      };
    }

    case actionTypes.LOAD_GRADER_DETAIL_SUCCESS: {
      return {
        ...state,
        graderDetail: action.data,
        isProcessLoadGraderDetail: false,
      };
    }

    case actionTypes.LOAD_GRADER_DETAIL_FAIL: {
      return {
        ...state,
        isProcessLoadGraderDetail: false,
      };
    }

    
    
    case actionTypes.REMOVE_GRADER: {
      return {
        ...state,
        removeGraderConfirm: null
      };
    }

    case actionTypes.REMOVE_GRADER_SUCCESS: {
      return {
        ...state,
        removeGraderConfirm: (action.data) ? action.data : null
      };
    }
    

    case actionTypes.RECOVERY_GRADER: {
      return {
        ...state,
        isRecoveryGraderSuccess: false
      };
    }

    case actionTypes.RECOVERY_GRADER_SUCCESS: {
      return {
        ...state,
        isRecoveryGraderSuccess: true
      };
    }

    case actionTypes.RECOVERY_GRADER_FAIL: {
      return {
        ...state,
        isRecoveryGraderSuccess: false
      };
    }


    case actionTypes.EDIT_GRADER_STATUS: {
      return {
        ...state,
        isUpdateGraderStatusSuccess: false,
        isUpdateGraderStatusFail: false,
        proceedDeactivateConfirm: false,
        confirmData: null
      };
    }

    case actionTypes.EDIT_GRADER_STATUS_SUCCESS: {
      return {
        ...state,
        isUpdateGraderStatusSuccess: true,
        proceedUpdateOrderLandfill: false,
        activeOrderList: null,
        proceedDeactivateConfirm: false,
        confirmData: null

      };
    }

    case actionTypes.EDIT_GRADER_STATUS_FAIL: {
      return {
        ...state,
        isUpdateGraderStatusFail: true
      };
    }

    case actionTypes.PROCEED_DEACTIVATE_CONFIRM: {
      return {
        ...state,
        proceedDeactivateConfirm: true,
        confirmData: {grader_id: action.data.grader_id, status: action.data.status, full_name: action.data.full_name}
      };
    }

    case actionTypes.PROCEED_UPDATE_ORDER_LANDFILL: {
      return {
        ...state,
        proceedUpdateOrderLandfill: true,
        activeOrderList: action.data.activeOrderList,

      };
    }

    case actionTypes.DIMISS_UPDATE_ORDER_LANDFILL: {
      return {
        ...state,
        proceedUpdateOrderLandfill: false,
        activeOrderList: null,

      };
    }

    case actionTypes.EDIT_GRADER_VERIFY_STATUS: {
      return {
        ...state,
        isUpdateGraderVerifyStatusSuccess: false,
        isUpdateGraderVerifyStatusFail: false
      };
    }

    case actionTypes.EDIT_GRADER_VERIFY_STATUS_SUCCESS: {
      return {
        ...state,
        isUpdateGraderVerifyStatusSuccess: true
      };
    }

    case actionTypes.EDIT_GRADER_VERIFY_STATUS_FAIL: {
      return {
        ...state,
        isUpdateGraderVerifyStatusFail: true
      };
    }


    case actionTypes.REJECT_GRADER_VERIFY_STATUS: {
      return {
        ...state,
        isRejectGraderVerifyStatusSuccess: false,
        isRejectGraderVerifyStatusFail: false
      };
    }

    case actionTypes.REJECT_GRADER_VERIFY_STATUS_SUCCESS: {
      return {
        ...state,
        isRejectGraderVerifyStatusSuccess: true
      };
    }

    case actionTypes.REJECT_GRADER_VERIFY_STATUS_FAIL: {
      return {
        ...state,
        isRejectGraderVerifyStatusFail: true
      };
    }

    case actionTypes.UPDATE_PRINTER_BINDING: {
      return {
        ...state,
        isUpdatePrinterBindingSuccess: false,
        isUpdatePrinterBindingFail: false
      };
    }

    case actionTypes.UPDATE_PRINTER_BINDING_SUCCESS: {
      return {
        ...state,
        isUpdatePrinterBindingSuccess: true
      };
    }

    case actionTypes.UPDATE_PRINTER_BINDING_FAIL: {
      return {
        ...state,
        isUpdatePrinterBindingFail: true
      };
    }


    case actionTypes.EDIT_GRADER_PUBLISH_STATUS: {
      return {
        ...state,
        isUpdateGraderPublishStatusSuccess: false
      };
    }

    case actionTypes.EDIT_GRADER_PUBLISH_STATUS_SUCCESS: {
      return {
        ...state,
        isUpdateGraderPublishStatusSuccess: true
      };
    }

    case actionTypes.EDIT_GRADER_PUBLISH_STATUS_FAIL: {
      return {
        ...state,
        isUpdateGraderPublishStatusSuccess: false
      };
    }

    case actionTypes.EDIT_GRADER_DETAIL: {
      return {
        ...state,
        isUpdateGraderDetailSuccess: false,
        isUpdateGraderDetailFail: false
      };
    }

    case actionTypes.EDIT_GRADER_DETAIL_SUCCESS: {
      return {
        ...state,
        isUpdateGraderDetailSuccess: true
      };
    }

    case actionTypes.EDIT_GRADER_DETAIL_FAIL: {
      return {
        ...state,
        isUpdateGraderDetailFail: true
      };
    }
    
    case actionTypes.EDIT_GRADER_QRCODE: {
      return {
        ...state,
        isUpdateGraderQRCodeSuccess: false,
        isUpdateGraderQRCodeFail: false
      };
    }

    case actionTypes.EDIT_GRADER_QRCODE_SUCCESS: {
      return {
        ...state,
        isUpdateGraderQRCodeSuccess: true
      };
    }

    case actionTypes.EDIT_GRADER_QRCODE_FAIL: {
      return {
        ...state,
        isUpdateGraderQRCodeFail: true
      };
    }

    
    case actionTypes.LOAD_GRADER_DEVICE_LIST: {
      let graderDeviceList = cloneDeep(state.graderDeviceList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderDeviceList.offset = action.data.offset;
        graderDeviceList.limit = action.data.limit;
      }

      return {
        ...state,
        graderDeviceList,
        isProcessLoadGraderDevice: true,
      };
    }

    case actionTypes.LOAD_GRADER_DEVICE_LIST_SUCCESS: {
      let graderDeviceList = cloneDeep(state.graderDeviceList);
      graderDeviceList.data = action.data.data;
      graderDeviceList.meta = {
        page: 1 + state.graderDeviceList.offset / state.graderDeviceList.limit,
        pageSize: state.graderDeviceList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderDeviceList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        isProcessLoadGraderDevice: false,
        graderDeviceList
      };
    }

    case actionTypes.LOAD_GRADER_DEVICE_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGraderDevice: false,
      };
    }
    
    case actionTypes.LOGOUT_GRADER_DEVICE: {
      return {
        ...state,
        isLogoutGraderDeviceSuccess: false,
        isLogoutGraderDeviceFail: false
      };
    }

    case actionTypes.LOGOUT_GRADER_DEVICE_SUCCESS: {
      return {
        ...state,
        isLogoutGraderDeviceSuccess: true
      };
    }

    case actionTypes.LOGOUT_GRADER_DEVICE_FAIL: {
      return {
        ...state,
        isLogoutGraderDeviceFail: true
      };
    }
    

    case actionTypes.REMOVE_GRADER_DEVICE: {
      return {
        ...state,
        isRemoveGraderDeviceSuccess: false,
        isRemoveGraderDeviceFail: false
      };
    }

    case actionTypes.REMOVE_GRADER_DEVICE_SUCCESS: {
      return {
        ...state,
        isRemoveGraderDeviceSuccess: true
      };
    }

    case actionTypes.REMOVE_GRADER_DEVICE_FAIL: {
      return {
        ...state,
        isRemoveGraderDeviceFail: true
      };
    }


    case actionTypes.SET_GRADER_DEVICE_DEV_MODE: {
      return {
        ...state,
        isUpdateGraderDeviceDevSuccess: false,
        isUpdateGraderDeviceDevFail: false,
      };
    }

    case actionTypes.SET_GRADER_DEVICE_DEV_MODE_SUCCESS: {
      return {
        ...state,
        isUpdateGraderDeviceDevSuccess: true,

      };
    }

    case actionTypes.SET_GRADER_DEVICE_DEV_MODE_FAIL: {
      return {
        ...state,
        isUpdateGraderDeviceDevFail: true
      };
    }
    

    case actionTypes.UPLOAD_GRADER_DOC: {
      return {
        ...state,
        isUploadGraderDocSuccess: false
      };
    }

    case actionTypes.UPLOAD_GRADER_DOC_SUCCESS: {
      return {
        ...state,
        isUploadGraderDocSuccess: true
      };
    }

    case actionTypes.UPLOAD_GRADER_DOC_FAIL: {
      return {
        ...state,
        isUploadGraderDocSuccess: false
      };
    }


    case actionTypes.UPLOAD_GRADER_BIZ_IMAGE: {
      return {
        ...state,
        isUploadGraderBizImageSuccess: false
      };
    }

    case actionTypes.UPLOAD_GRADER_BIZ_IMAGE_SUCCESS: {
      return {
        ...state,
        isUploadGraderBizImageSuccess: true
      };
    }

    case actionTypes.UPLOAD_GRADER_BIZ_IMAGE_FAIL: {
      return {
        ...state,
        isUploadGraderBizImageSuccess: false
      };
    }


    case actionTypes.REMOVE_GRADER_BIZ_IMAGE: {
      return {
        ...state,
        isRemoveGraderBizImageSuccess: false
      };
    }

    case actionTypes.REMOVE_GRADER_BIZ_IMAGE_SUCCESS: {
      return {
        ...state,
        isRemoveGraderBizImageSuccess: true
      };
    }

    case actionTypes.REMOVE_GRADER_BIZ_IMAGE_FAIL: {
      return {
        ...state,
        isRemoveGraderBizImageSuccess: false
      };
    }


    
  
    case actionTypes.GRADER_DOCUMENTATION_COUNT: {
      
      return {
        ...state,
        graderDocumentationCount: {}
      };
    }

    case actionTypes.GRADER_DOCUMENTATION_COUNT_SUCCESS: {
    
      return {
        ...state,
        graderDocumentationCount:action.data
      };
    }

    case actionTypes.GRADER_DOCUMENTATION_COUNT_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.GRADER_DOCUMENTATION_LIST: {
      let graderDocumentList = cloneDeep(state.graderDocumentList);

      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderDocumentList.offset = action.data.offset;
        graderDocumentList.limit = action.data.limit;
      }

      if (action.data.offset === 0) 
        graderDocumentList.data = [];

      return {
        ...state,
        graderDocumentList,
        isProcessLoadGraderDocument: true
      };
    }

    case actionTypes.GRADER_DOCUMENTATION_LIST_SUCCESS: {
      let graderDocumentList = cloneDeep(state.graderDocumentList);
      graderDocumentList.data = action.data.data;
      graderDocumentList.meta = {
        page: 1 + state.graderDocumentList.offset / state.graderDocumentList.limit,
        pageSize: state.graderDocumentList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderDocumentList.limit
        ),
        total: action.data.recordsTotal
      };
      
      return {
        ...state,
        graderDocumentList,
        isProcessLoadGraderDocument:false,
      };
    }

    case actionTypes.GRADER_DOCUMENTATION_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGraderDocument:false,
      };
    }
    
    case actionTypes.RESET_GRADER_DOCUMENTATION_LIST: {

      return {
        ...state,
        graderDocumentList: {
          data: [],
          offset: 0,
          limit: 10,
          meta: {
            page: 1,
            pageSize: 0,
            pageTotal: 1,
            total: 0,
            pageSizeOptions: [5, 10, 20, 30, 50, 100]
          }
        },
        isProcessLoadGraderDocument:false,
      };
    }
    

    case actionTypes.APPROVE_GRADER_DOCUMENTATION: {
      return {
        ...state,
        isApproveGraderDocumentSuccess: false
      };
    }

    case actionTypes.APPROVE_GRADER_DOCUMENTATION_SUCCESS: {
      return {
        ...state,
        isApproveGraderDocumentSuccess: true
      };
    }

    case actionTypes.APPROVE_GRADER_DOCUMENTATION_FAIL: {
      return {
        ...state,
        isApproveGraderDocumentSuccess: false
      };
    }
    

    case actionTypes.REJECT_GRADER_DOCUMENTATION: {
      return {
        ...state,
        isRejectGraderDocumentSuccess: false
      };
    }

    case actionTypes.REJECT_GRADER_DOCUMENTATION_SUCCESS: {
      return {
        ...state,
        isRejectGraderDocumentSuccess: true
      };
    }

    case actionTypes.REJECT_GRADER_DOCUMENTATION_FAIL: {
      return {
        ...state,
        isRejectGraderDocumentSuccess: false
      };
    }



    /* ===== GRADER ZONE ===== */
    case actionTypes.LOAD_GRADER_ZONE_LIST: {
      let graderZoneList = cloneDeep(state.graderZoneList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderZoneList.offset = action.data.offset;
        graderZoneList.limit = action.data.limit;
      }

      return {
        ...state,
        graderZoneList,
        isProcessLoadGraderZone: true,
      };
    }

    case actionTypes.LOAD_GRADER_ZONE_LIST_SUCCESS: {
      let graderZoneList = cloneDeep(state.graderZoneList);
      graderZoneList.data = action.data.data;
      graderZoneList.meta = {
        page: 1 + state.graderZoneList.offset / state.graderZoneList.limit,
        pageSize: state.graderZoneList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderZoneList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        isProcessLoadGraderZone: false,
        graderZoneList
      };
    }

    case actionTypes.LOAD_GRADER_ZONE_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGraderZone: false,
      };
    }

    
    case actionTypes.GRADER_ZONE_COUNT: {
      
      return {
        ...state,
        graderZoneCount: {}
      };
    }

    case actionTypes.GRADER_ZONE_COUNT_SUCCESS: {
    
      return {
        ...state,
        graderZoneCount:action.data
      };
    }

    case actionTypes.GRADER_ZONE_COUNT_FAIL: {
      return {
        ...state
      };
    }

    case actionTypes.LOAD_EXPRESS_PACKING_HISTORY_LIST: {
      let expressPackingHistoryList = cloneDeep(state.expressPackingHistoryList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        expressPackingHistoryList.offset = action.data.offset;
        expressPackingHistoryList.limit = action.data.limit;
      }

      return {
        ...state,
        expressPackingHistoryList,
        isProcessLoadExpressPackingHistoryList: true,
      };
    }

    case actionTypes.LOAD_EXPRESS_PACKING_HISTORY_LIST_SUCCESS: {
      let expressPackingHistoryList = cloneDeep(state.expressPackingHistoryList);

      if(!action.data.data.export)
      {
        expressPackingHistoryList.exportSuccess = false
        expressPackingHistoryList.data = action.data.data;
        expressPackingHistoryList.meta = {
          page: 1 + state.expressPackingHistoryList.offset / state.expressPackingHistoryList.limit,
          pageSize: state.expressPackingHistoryList.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.expressPackingHistoryList.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        expressPackingHistoryList.exportSuccess = true
      }

      return {
        ...state,
        isProcessLoadExpressPackingHistoryList: false,
        expressPackingHistoryList
      };
    }

    case actionTypes.LOAD_EXPRESS_PACKING_HISTORY_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadExpressPackingHistoryList: false,
      };
    }

    
    case actionTypes.LOAD_EXPRESS_PACKING_LIST_DETAIL: {
      
      return {
        ...state,
        expressPackingDetail: {}
      };
    }

    case actionTypes.LOAD_EXPRESS_PACKING_LIST_DETAIL_SUCCESS: {
    
      return {
        ...state,
        expressPackingDetail:action.data
      };
    }

    case actionTypes.LOAD_EXPRESS_PACKING_LIST_DETAIL_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.GET_EXPRESS_PACKING_LIST_PDF: {
      
      return {
        ...state,
        expressPackingPDF: ""
      };
    }

    case actionTypes.GET_EXPRESS_PACKING_LIST_PDF_SUCCESS: {
    
      return {
        ...state,
        expressPackingPDF: action.data
      };
    }

    case actionTypes.GET_EXPRESS_PACKING_LIST_PDF_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.GET_EXPRESS_PACKING_LIST_STACK: {
      
      return {
        ...state,
        expressPackingListStack: []
      };
    }

    case actionTypes.GET_EXPRESS_PACKING_LIST_STACK_SUCCESS: {
    
      return {
        ...state,
        expressPackingListStack: action.data
      };
    }

    case actionTypes.GET_EXPRESS_PACKING_LIST_STACK_FAIL: {
      return {
        ...state
      };
    }
    
    

    case actionTypes.LOAD_RECYCLING_PACKING_HISTORY_LIST: {
      let recyclingPackingHistoryList = cloneDeep(state.recyclingPackingHistoryList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        recyclingPackingHistoryList.offset = action.data.offset;
        recyclingPackingHistoryList.limit = action.data.limit;
      }

      return {
        ...state,
        recyclingPackingHistoryList,
        isProcessLoadRecyclingPackingHistoryList: true,
      };
    }

    case actionTypes.LOAD_RECYCLING_PACKING_HISTORY_LIST_SUCCESS: {
      let recyclingPackingHistoryList = cloneDeep(state.recyclingPackingHistoryList);
      
      if(!action.data.data.export)
      {
        recyclingPackingHistoryList.exportSuccess = false
        recyclingPackingHistoryList.data = action.data.data;
        recyclingPackingHistoryList.meta = {
          page: 1 + state.recyclingPackingHistoryList.offset / state.recyclingPackingHistoryList.limit,
          pageSize: state.recyclingPackingHistoryList.limit,
          pageTotal: Math.ceil(
            action.data.recordsTotal / state.recyclingPackingHistoryList.limit
          ),
          total: action.data.recordsTotal
        };
      }else{
        recyclingPackingHistoryList.exportSuccess = true
      }


      return {
        ...state,
        isProcessLoadRecyclingPackingHistoryList: false,
        recyclingPackingHistoryList
      };
    }

    case actionTypes.LOAD_RECYCLING_PACKING_HISTORY_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadRecyclingPackingHistoryList: false,
      };
    }

    
    case actionTypes.LOAD_RECYCLING_PACKING_LIST_DETAIL: {
      
      return {
        ...state,
        recyclingPackingDetail: {}
      };
    }

    case actionTypes.LOAD_RECYCLING_PACKING_LIST_DETAIL_SUCCESS: {
      
      return {
        ...state,
        recyclingPackingDetail:action.data
      };
    }

    case actionTypes.LOAD_RECYCLING_PACKING_LIST_DETAIL_FAIL: {
      return {
        ...state
      };
    }
    
    
    case actionTypes.GET_RECYCLING_PACKING_LIST_PDF: {
      
      return {
        ...state,
        recyclingPackingPDF: ""
      };
    }

    case actionTypes.GET_RECYCLING_PACKING_LIST_PDF_SUCCESS: {
    
      return {
        ...state,
        recyclingPackingPDF: action.data
      };
    }

    case actionTypes.GET_RECYCLING_PACKING_LIST_PDF_FAIL: {
      return {
        ...state
      };
    }

    
    case actionTypes.GET_RECYCLING_PACKING_LIST_STACK: {
      
      return {
        ...state,
        recyclingPackingListStack: []
      };
    }

    case actionTypes.GET_RECYCLING_PACKING_LIST_STACK_SUCCESS: {
    
      return {
        ...state,
        recyclingPackingListStack: action.data
      };
    }

    case actionTypes.GET_RECYCLING_PACKING_LIST_STACK_FAIL: {
      return {
        ...state
      };
    }
    /* ===== GRADER ZONE ===== */
    

    
    case actionTypes.LOAD_GRADER_CARBON_STOCK_LIST: {
      
      return {
        ...state,
        graderCarbonStockList: []
      };
    }

    case actionTypes.LOAD_GRADER_CARBON_STOCK_LIST_SUCCESS: {
      
      return {
        ...state,
        graderCarbonStockList:action.data
      };
    }

    case actionTypes.LOAD_GRADER_CARBON_STOCK_LIST_FAIL: {
      return {
        ...state
      };
    }
    
    
    case actionTypes.SET_GRADER_CARBON_STOCK: {
      
      return {
        ...state,
        isSetGraderCarbonStockSuccess: false,
        isSetGraderCarbonStockFail: false,
      };
    }

    case actionTypes.SET_GRADER_CARBON_STOCK_SUCCESS: {
    
      return {
        ...state,
        isSetGraderCarbonStockSuccess: true,
      };
    }

    case actionTypes.SET_GRADER_CARBON_STOCK_FAIL: {
      return {
        ...state,
        isSetGraderCarbonStockFail: true,
      };
    }

        
    case actionTypes.REMOVE_GRADER_CARBON_STOCK: {
      
      return {
        ...state,
        isRemoveGraderCarbonStockSuccess: false,
        isRemoveGraderCarbonStockFail: false,
      };
    }

    case actionTypes.REMOVE_GRADER_CARBON_STOCK_SUCCESS: {
    
      return {
        ...state,
        isRemoveGraderCarbonStockSuccess: true,
      };
    }

    case actionTypes.REMOVE_GRADER_CARBON_STOCK_FAIL: {
      return {
        ...state,
        isRemoveGraderCarbonStockFail: true,
      };
    }

    /* ===== GRADER PRINTER ===== */
    case actionTypes.LOAD_GRADER_PRINTER_LIST: {
      let graderPrinterList = cloneDeep(state.graderPrinterList);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderPrinterList.offset = action.data.offset;
        graderPrinterList.limit = action.data.limit;
      }

      return {
        ...state,
        graderPrinterList,
        isProcessLoadGraderPrinter: true,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_LIST_SUCCESS: {
      let graderPrinterList = cloneDeep(state.graderPrinterList);
      graderPrinterList.data = action.data.data;
      graderPrinterList.meta = {
        page: 1 + state.graderPrinterList.offset / state.graderPrinterList.limit,
        pageSize: state.graderPrinterList.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderPrinterList.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        isProcessLoadGraderPrinter: false,
        graderPrinterList
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_LIST_FAIL: {
      return {
        ...state,
        isProcessLoadGraderPrinter: false,
      };
    }


    case actionTypes.GRADER_PRINTER_COUNT: {
      return {
        ...state,
        graderPrinterCount: {}
      };
    }

    case actionTypes.GRADER_PRINTER_COUNT_SUCCESS: {
      return {
        ...state,
        graderPrinterCount: action.data
      };
    }

    case actionTypes.GRADER_PRINTER_COUNT_FAIL: {
      return {
        ...state
      };
    }


    case actionTypes.LOAD_GRADER_PRINTER_DETAIL: {
      return {
        ...state,
        isProcessLoadGraderPrinterDetail: true,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_DETAIL_SUCCESS: {
      return {
        ...state,
        graderPrinterDetail: action.data,
        isProcessLoadGraderPrinterDetail: false,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_DETAIL_FAIL: {
      return {
        ...state,
        isProcessLoadGraderPrinterDetail: false,
      };
    }


    case actionTypes.CREATE_GRADER_PRINTER: {
      return {
        ...state,
        isCreateGraderPrinterSuccess: false,
        isCreateGraderPrinterFail: false,
      };
    }

    case actionTypes.CREATE_GRADER_PRINTER_SUCCESS: {
      return {
        ...state,
        isCreateGraderPrinterSuccess: true,
      };
    }

    case actionTypes.CREATE_GRADER_PRINTER_FAIL: {
      return {
        ...state,
        isCreateGraderPrinterFail: true,
      };
    }


    case actionTypes.EDIT_GRADER_PRINTER: {
      return {
        ...state,
        isUpdateGraderPrinterSuccess: false,
        isUpdateGraderPrinterFail: false,
        editGraderPrinterConfirm: null,
      };
    }

    case actionTypes.EDIT_GRADER_PRINTER_CONFIRM: {
      return {
        ...state,
        editGraderPrinterConfirm: action.data,
      };
    }

    case actionTypes.EDIT_GRADER_PRINTER_SUCCESS: {
      return {
        ...state,
        isUpdateGraderPrinterSuccess: true,
      };
    }

    case actionTypes.EDIT_GRADER_PRINTER_FAIL: {
      return {
        ...state,
        isUpdateGraderPrinterFail: true,
      };
    }


    case actionTypes.REMOVE_GRADER_PRINTER: {
      return {
        ...state,
        isRemoveGraderPrinterSuccess: false,
        isRemoveGraderPrinterFail: false,
        removeGraderPrinterConfirm: null,
      };
    }

    case actionTypes.REMOVE_GRADER_PRINTER_CONFIRM: {
      return {
        ...state,
        removeGraderPrinterConfirm: action.data,
      };
    }


    case actionTypes.LOAD_GRADER_PRINTER_TASK_DISTANCE: {
      return {
        ...state,
        graderPrinterTaskDistance: null,
        isProcessGraderPrinterTaskDistance: true,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_TASK_DISTANCE_SUCCESS: {
      return {
        ...state,
        graderPrinterTaskDistance: action.data,
        isProcessGraderPrinterTaskDistance: false,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_TASK_DISTANCE_FAIL: {
      return {
        ...state,
        isProcessGraderPrinterTaskDistance: false,
      };
    }

    case actionTypes.REMOVE_GRADER_PRINTER_SUCCESS: {
      return {
        ...state,
        isRemoveGraderPrinterSuccess: true,
      };
    }

    case actionTypes.REMOVE_GRADER_PRINTER_FAIL: {
      return {
        ...state,
        isRemoveGraderPrinterFail: true,
      };
    }


    case actionTypes.LOAD_GRADER_PRINTER_STATUS_LOG: {
      let graderPrinterStatusLog = cloneDeep(state.graderPrinterStatusLog);
      if (
        Object.keys(action.data).includes("offset") &&
        Object.keys(action.data).includes("limit")
      ) {
        graderPrinterStatusLog.offset = action.data.offset;
        graderPrinterStatusLog.limit = action.data.limit;
      }

      return {
        ...state,
        graderPrinterStatusLog,
        isProcessLoadGraderPrinterStatusLog: true,
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_STATUS_LOG_SUCCESS: {
      let graderPrinterStatusLog = cloneDeep(state.graderPrinterStatusLog);
      graderPrinterStatusLog.data = action.data.data;
      graderPrinterStatusLog.meta = {
        page: 1 + state.graderPrinterStatusLog.offset / state.graderPrinterStatusLog.limit,
        pageSize: state.graderPrinterStatusLog.limit,
        pageTotal: Math.ceil(
          action.data.recordsTotal / state.graderPrinterStatusLog.limit
        ),
        total: action.data.recordsTotal
      };

      return {
        ...state,
        isProcessLoadGraderPrinterStatusLog: false,
        graderPrinterStatusLog
      };
    }

    case actionTypes.LOAD_GRADER_PRINTER_STATUS_LOG_FAIL: {
      return {
        ...state,
        isProcessLoadGraderPrinterStatusLog: false,
      };
    }
    /* ===== END GRADER PRINTER ===== */

    default:
      return state;
  }
}
